import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/salidas';
import Salidas from './SalidasList';

const ms2p = (state) => {
  return {
    ...state.salidas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Salidas);